import useSWRImmutable from 'swr/immutable'
import { Parameter$getCoordinatesSearchV2 } from '~/api/gen'
import { fetchSearchCoordinates } from '../utils/fetchSearchCoordinates'
import { getSearchCoordinatesKey } from '../utils/getSearchCoordinatesKey'

export const useSearchCoordinates = (
  parameter: Parameter$getCoordinatesSearchV2
) => {
  return useSWRImmutable(
    getSearchCoordinatesKey(parameter),
    fetchSearchCoordinates
  )
}
